import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const NoteFullPage = lazy(() => import("@/app/NoteFullPage"));

export const Route = createFileRoute("/campaign/$shortId/map-note/$mapNoteId/entry/$entryId")({
  component: NoteFullPage,
});
